import blockquote from './blockquote'
import code from './code'
import heading from './heading'
import image from './image'
import inlineCode from './inline-code'
import link from './link'
import list from './list'
import listItem from './list-item'
import paragraph from './paragraph'
import table from './table'
import tableCell from './table-cell'
import tableHead from './table-head'
import thematicBreak from './thematic-break'

export default {
  link,
  thematicBreak,
  heading,
  image,
  list,
  listItem,
  paragraph,
  table,
  tableCell,
  tableHead,
  code,
  inlineCode,
  blockquote,
}
